export const ANALYSIS_LIMITS = {
  ENTERPRISE: 100000, // 100 licenses × 1000 analyses per license
} as const;

export const ANALYSES_PER_LICENSE = 1000;
export const MAX_LICENSES_PER_ORGANIZATION = 100;

export const USAGE_THRESHOLDS = {
  WARNING: 0.8, // Show warning at 80% usage
  CRITICAL: 0.95, // Show critical warning at 95% usage
} as const;